import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { JoinNetworkForm } from './JoinNetworkForm';
export function MakeDifferenceCTA() {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  const [formOpen, setFormOpen] = useState(false);
  const {
    t,
    language
  } = useLanguage();
  return <section ref={ref} className="bg-haa-blue py-10 px-4" aria-label="Join our network" data-id="element-2777">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.6,
      ease: [0.16, 1, 0.3, 1]
    }} className="flex flex-col items-center gap-4 text-center" data-id="element-2778">
        <p className="font-nunito text-white/80 text-sm uppercase tracking-[0.3em] font-semibold" data-id="element-2779">
          {language === 'ES' ? 'Haz la Diferencia' : 'Make a Difference'}
        </p>
        <h2 className="font-bebas text-4xl sm:text-5xl text-white tracking-wider leading-none" data-id="element-2780">
          {t('leadership.cta.heading')}
        </h2>
        <p className="font-nunito text-white/80 text-base max-w-2xl mx-auto leading-relaxed" data-id="element-2781">
          {language === 'ES' ? '¿Eres estudiante universitario, empresario, profesional, líder comunitario, líder religioso, quieres aprender más o simplemente conectar? Únete a nuestra red y ayuda a construir una plataforma compartida que eleve las voces hondureño-americanas en ambos países.' : 'Are you a college student, business owner, professional, community leader, faith leader, wanting to learn more, or just looking to connect? Join our network and help build a shared platform elevating Honduran-American voices across both countries.'}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4 mt-2" data-id="element-2782">
          <motion.button onClick={() => setFormOpen(true)} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center gap-2 bg-white text-haa-blue font-nunito font-bold text-sm px-8 py-3 rounded-full shadow-lg hover:bg-haa-skyblue hover:text-white transition-all duration-300" data-id="element-2783">
            {t('leadership.cta.button')}
            <ArrowRightIcon className="w-4 h-4" data-id="element-2784" />
          </motion.button>
        </div>
      </motion.div>

      <JoinNetworkForm isOpen={formOpen} onClose={() => setFormOpen(false)} data-id="element-2785" />
    </section>;
}